import axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { backendBookartUrl } from "../library/constants";
import { adminValidation } from "../library/service";

const CartDetailsAdmin = (props) => {
  const navigate = useNavigate();
  const [orderId] = useState(props.data);
  const [cartItems, setCartItems] = useState([]);
  const [cartId, setCartId] = useState([]);
  const [checkboxes, setCheckboxes] = useState([]);
  const [admin, setAdmin] = useState(false);

  useEffect(() => {
    getCartData();
    authUser();
    adminAuth();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const authUser = async () => {
    const token = window.sessionStorage.getItem("JWTtoken");
  
    if (!token) {
      navigate("/");
      return; 
    }
  };


  const adminAuth = async () => {
    const authorized = await adminValidation();
    if (!authorized) {
      // Redirect to login page if the token has expired
      navigate('/');
    } else if (authorized && authorized.data.is_admin) {
      setAdmin(true);
    } else {
      navigate("/unAuthorized");
    }
  };


  const getCartData = () => {
    console.log("cart order ID::", props.data);
    const token = window.sessionStorage.getItem("JWTtoken");
    var data = JSON.stringify({
      orderID: orderId,
    });
    var config = {
      method: "post",
      url: `${backendBookartUrl}/cartDetails`,
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      data: data,
    };
    axios(config)
      .then((response) => {
        setCartItems(response.data.cartDetails);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const checkmark = (props) => {
    setCartId((prevCartId) => [...prevCartId, props.target.value]);
    setCheckboxes((prevCheckboxes) => [...prevCheckboxes, props.target]);
  };

  const unCheck = (value) => {
    value.checked = false;
  };

  const sendUpdate = (props) => {
    const token = window.sessionStorage.getItem("JWTtoken");
    let statusValue = props.target.innerText;
    checkboxes.forEach((el) => unCheck(el));
    const data = JSON.stringify({
      status: statusValue,
      orderID: orderId,
      cartIDs: cartId,
    })

    var config = {
      method: "post",
      url: `${backendBookartUrl}/cartDetails/status`,
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      data:data,
    };
    axios(config)
      .then((response) => {
        setCartItems(response.data.cartDetails);
        setCartId([]);
        setCheckboxes([]);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  if (!admin) {
    return <div></div>;
  } else {
    return (
      <React.Fragment>

        <section className="container min-height60">

          <div>
            <h2 className="margin-top-30">Cart Details</h2>
            <div className="dropdown margin-top-30">
              <button
                className="dropdown-toggle es-button primary"
                id="dropdownMenuLink"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Update Status
              </button>

              <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <li>
                  <button
                    onClick={sendUpdate}
                    className="dropdown-item"
                    name="submit-button"
                    value="processed"
                  >
                    processed
                  </button>
                </li>
                <li>
                  <button
                    onClick={sendUpdate}
                    className="dropdown-item"
                    name="submit-button"
                    value="partially fulfilled"
                  >
                    partially fulfilled
                  </button>
                </li>
                <li>
                  <button
                    onClick={sendUpdate}
                    className="dropdown-item"
                    name="submit-button"
                    value="fulfilled"
                  >
                    fulfilled
                  </button>
                </li>
                <li>
                  <button
                    onClick={sendUpdate}
                    className="dropdown-item"
                    name="submit-button"
                    value="credit on hold"
                  >
                    credit on hold
                  </button>
                </li>
                <li>
                  <button
                    onClick={sendUpdate}
                    className="dropdown-item"
                    name="submit-button"
                    value="Backordered"
                  >
                    Backordered
                  </button>
                </li>
                <li>
                  <button
                    onClick={sendUpdate}
                    className="dropdown-item"
                    name="submit-button"
                    value="Cancelled"
                  >
                    Cancelled
                  </button>
                </li>
                <li>
                  <button
                    onClick={sendUpdate}
                    className="dropdown-item"
                    name="submit-button"
                    value="Not Processed"
                  >
                    Not Processed
                  </button>
                </li>
              </ul>
            </div>
            <div className="margin-top-30">
              <table className="table table-borderless">
                <thead className="cart-table-header sticky-table-head">
                  <tr>
                    <th scope="col">Order No</th>
                    <th scope="col">Title</th>
                    <th scope="col">Quantity</th>
                    <th scope="col">Total Price</th>
                    <th scope="col">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {cartItems.map((el) => (
                    <tr key={el.cart_id}>
                      <td className="checkbox-orderDetails-admin">
                        <label className="es-check small">
                          <input
                            form="myForm"
                            className="es-check-input allcheckboxes "
                            name={el.order_no}
                            value={el.cart_id}
                            type="checkbox"
                            onClick={checkmark}
                          />
                        </label>
                        <span className="color-light-ash font-16">{orderId}</span>
                      </td>
                      <td className="color-light-ash font-16">{el.title}</td>
                      <td className="color-light-ash font-16">{el.quantity}</td>
                      <td className="color-light-ash font-16">{el.total_price}</td>
                      <td className="color-light-ash font-16">{el.status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

      </React.Fragment>
    );
  }
};

export default CartDetailsAdmin;
